module.exports = __webpack_public_path__ + "static/media/caseys.e7ec53bf.svg";